import React from 'react'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { IconList } from '../../../../../../shared/icon/icon'
import { useParamsInt } from '../../../../../../shared/hooks/location'
import { Menu, MenuPurge, MenuRestore } from '../../../../../../shared/menu/menu'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { useApiListAppBuildVersion } from '../../../../../../api-new/state/config'
import { useRoleSysApp } from '../../../../../../role/hook/role-sys'
import { TableAgClient } from '../../../../../../shared/table-builder/table-ag-client'
import { ColumnDateTime, ColumnMenu, ColumnSize, ColumnText } from '../../../../../../shared/table-builder/table-columns'
import { recycleErrorMessage } from '../../../../../../shared/error/server-message'
import { ErrorReference } from '../../../../../../shared/error/error-reference'
import { useErrorLine } from '../../../../../../shared/error/use-error-line'

// Recycle bin for uploaded build artifacts (APK/IPA/player builds).
//
// Build versions used to hard-delete: the row was removed with Unscoped() and
// the S3 object destroyed inline, so a mis-click was unrecoverable. They now
// soft-delete like app / app-store / app-version, which makes this view the
// only way to reach a deleted build — and the only way to purge one, since the
// stored artifact is not released until purge.
//
// storageKey and contentLength are shown deliberately: unlike app versions,
// which are identified by name, a deleted build is identified by its artifact,
// and the size is what tells you how much storage a purge will actually free.
export const AppBuildVersionRecycle = () => {
  const { appID, appStoreID, appVersionID } = useParamsInt()

  const apiListAppBuildVersion = useApiListAppBuildVersion()

  const roleSysApp = useRoleSysApp()

  const [error, failure, setError] = useErrorLine()

  const handleReady = () => apiListAppBuildVersion.get('deleted')
  const handleDestroyed = () => apiListAppBuildVersion.init()

  const handleRestore = async id => {
    setError(null)
    try {
      await apiListAppBuildVersion.put(`${id}/restore`)
    } catch (err) {
      setError(recycleErrorMessage(err, 'That build was already removed.'), err)
    }
    await apiListAppBuildVersion.get('deleted')
  }

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconList} text="recycle bin">
        <CardFullHeightScrollY title="recycle bin">
          {error &&
            <p className="text-danger" role="alert">
              {error}
            </p>}
          {error && <ErrorReference error={failure} className="mb-3" />}
          <TableAgClient apiList={apiListAppBuildVersion} onReady={handleReady} onDestoryed={handleDestroyed}>
            <ColumnDateTime field="createdAt" />
            <ColumnText field="filename" />
            <ColumnText field="storageKey" />
            <ColumnSize field="contentLength" />
            <ColumnText field="uploadedBy" />
            <ColumnText field="note" />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuRestore onClick={() => handleRestore(row.id)} show={roleSysApp.accessDelete} />
                  <MenuPurge
                    to={`/admin/app/edit/${appID}/store/edit/${appStoreID}/version/edit/${appVersionID}/version/recycle/purge/${row.id}`}
                    show={roleSysApp.accessPurge}
                    pin
                  />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
